var _ = require('lodash');
var dateFormat = require('dateformat');

/**
 * Type coercion from anything to int or 0
 * @param str
 * NOTE By design this takes one argument (so it can be directly used in mapping functions)
 * @returns {*|number}
 */
var toInt = function(str){//NOTE By design this takes one argument (so it can be directly used in mapping functions)
	return _.parseInt(_.isString(str) ? str.replace(/[^\-0-9.]/g, '') : str, 10) || 0;
};

/**
 * Type coercion from anything to float or 0
 * @param str
 * NOTE By design this takes one argument (so it can be directly used in mapping functions)
 * @returns {*|number}
 */
var toFloat = function(str){//NOTE By design this takes one argument (so it can be directly used in mapping functions)
	  return parseFloat(_.isString(str) ? str.replace(/[^\-0-9.]/g, '') : str) || 0;
};

/**
 * Take a balboa ISO8601 datetime and turn it into a js date
 * @param timestamp
 */
var convertFromISO8601 = function(timestamp){
	var day = _.map(timestamp.split(/\D/), toInt);
	day[1] -= 1;
	var d = new Date(Date.UTC.apply(Date, day));
	return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
};

/**
 * Our own ISO8601 formatter, since Date.toISOString() converts
 * to UTC first, and we don't want that.
 *
 * @param date
 * @returns string
 */
var returnISO8601 = (function(){
	var pad = function(number){
		if(number < 10){
			return '0' + number;
		}
		return number;
	};
	return function(date){
		return date.getFullYear() +
			'-' + pad(date.getMonth() + 1) +
			'-' + pad(date.getDate()) +
			'T' + pad(date.getHours()) +
			':' + pad(date.getMinutes()) +
			':' + pad(date.getSeconds());
	};
}());

var FIX_fromISO8601 = function(obj, fields){
	_.each(_.filter(_.flattenDeep([fields]), _.isString), function(field){
		if(_.has(obj, field + '_ISO8601') && _.has(obj, field)){
			obj[field] = obj[field] < 1 ? null : convertFromISO8601(obj[field + '_ISO8601']);
		}
	});
	return obj;
};
var FIX_fromISO8601_or_DateConstructor = function(obj, fields){
	_.each(_.filter(_.flattenDeep([fields]), _.isString), function(field){
		if(_.has(obj, field + '_ISO8601') && _.has(obj, field)){
			obj[field] = obj[field] < 1 ? null : convertFromISO8601(obj[field + '_ISO8601']);
		}else if(_.has(obj, field)){
			obj[field] = new Date(obj[field]);
		}
	});
	return obj;
};
var FIX_toISO8601 = function(obj, fields){
	_.each(_.filter(_.flattenDeep([fields]), _.isString), function(field){
		if(_.has(obj, field)){
			obj[field + '_ISO8601'] = _.isDate(obj[field]) ? returnISO8601(obj[field]) : null;
		}
	});
	return obj;
};

var cleanup_ids = function(ids){
	return _.uniq(_.filter(_.map(ids, toInt), function(id){
		return id > 0;
	}));
};

var toMpURL = function(url, bureau_id){
	if((typeof MP !== 'undefined') && _.isFunction(MP && MP.toMpURL)){
		return MP.toMpURL(url, bureau_id);
	}
	return url;
};

var StoredFile_Balboa3toJS = function(StoredFile){
	StoredFile.id = toInt(StoredFile.id);
	StoredFile.eid = toInt(StoredFile.eid);
	StoredFile.sids = cleanup_ids(StoredFile.sids);
	StoredFile.postdate = StoredFile.postdate < 1 ? null : convertFromISO8601(StoredFile.postdate_iso8601);
	return StoredFile;
};
var StoredFile_JStoBalboa3 = function(StoredFile){
	if(_.isDate(StoredFile.postdate)){
		StoredFile.postdate_iso8601 = returnISO8601(StoredFile.postdate);
	}
	return StoredFile;
};

var fixMPcontractDates = function(MPcontract){
	_.each(['created', 'buyer_signed', 'speaker_signed'], function(field){
		if(MPcontract[field] !== false){
			MPcontract[field] = convertFromISO8601(MPcontract[field + '_ISO8601']);
		}
	});
	return MPcontract;
};

var isNumber = function(n){//What does NaN stand for? ... yep Not a Number!
	return _.isNumber(n) && !_.isNaN(n);
};

var isValue = function(obj){
	return !_.isObject(obj) && !_.isArray(obj);
};

var isBlank = function(str){
	return _.isEmpty(str) || !_.isString(str) || str.trim().length === 0;
};

/**
 * Get a value out of a nested data structure at a given path.
 *
 * 5 === getIn({a: {b: 5}}, ['a', 'b'])
 * 5 === getIn({a: {b: [1, 5]}}, ['a', 'b', 1])
 */
var getIn = function(obj, path){
	if(!_.isArray(path)){
		return null;
	}
	if(_.isEmpty(path)){
		return obj;
	}
	var key = _.first(path);
	if(_.has(obj, key)){
		return getIn(obj[key], _.tail(path));
	}
	return null;
};


/**
 * deepDiff
 * Compares two values, returns all the paths that are either, the same, added, removed, or changed.
 *
 */
var deepDiff = function deepDiff(a, b, path){
	if(_.isFunction(a) || _.isFunction(b)){
		return null;
	}

	path = _.isArray(path) ? path : [];

	var diff = {
		same: [],
		added: [],
		removed: [],
		changed: []
	};

	if(isValue(a) || isValue(b)){
		if(a === b){
			diff.same = [path];
		}else if(_.isUndefined(a)){
			diff.added = [path];
		}else if(_.isUndefined(b)){
			diff.removed = [path];
		}else{
			diff.changed = [path];
		}

	}else{
		_.each(_.uniq(_.keys(a).concat(_.keys(b))), function(key){
			if(diff === null){
				return;
			}
			var d = deepDiff(a[key], b[key], path.concat([key]));
			if(d === null){
				diff = null;
				return;
			}

			_.each(diff, function(v, type){
				if(_.isArray(d[type]) && d[type].length > 0){
					diff[type] = diff[type].concat(d[type]);
				}
			});
		});
	}
	return diff;
};

var flagsAsMap_to_Flags = function(flags_as_map){
	return _.reduce(flags_as_map, function(total, f) {
		return total + (f.is_set ? f.intval : 0);
	}, 0);
};

var convertBalboa3ToJS = {
	Flight: function(flight){
		flight.id = toInt(flight.id);
		flight.eid = toInt(flight.eid);
		flight.cost = toFloat(flight.cost);
		flight.legs = _.map(flight.legs, function(leg){
			leg.id = toInt(leg.id);
			leg.legcost = toFloat(leg.legcost);
			return FIX_fromISO8601_or_DateConstructor(leg, ['legleave', 'legarrive']);
		});
		return flight;
	},
	Hotel: function(hotel){
		hotel.id = toInt(hotel.id);
		hotel.eid = toInt(hotel.eid);
		return FIX_fromISO8601(hotel, ['checkindate', 'checkoutdate']);
	},
	Ground: function(ground){
		ground.id = toInt(ground.id);
		ground.eid = toInt(ground.eid);
		ground.cost = toFloat(ground.cost);
		return FIX_fromISO8601(ground, 'starttime');
	},
	Service: function(item){
		item.fee = toFloat(item.fee);
		return FIX_fromISO8601(item, 'due');
	}
};

module.exports = {
	/////////////////////////////////////////////////////////////////////////////////////////////////////
	// Functions for eSpeakers Data
	get_selected_speaker_id: function(event){
		if(!event || !_.isArray(event.sids)){
			return null;
		}
		var sid = toInt(_.first(event.sids));
		return sid > 0 ? sid : null;
	},
	venue_to_string: function(venue){
		var parts = [];
		if(venue && venue.address){
			parts.push(venue.address);
		}
		//building
		if(venue && venue.city){
			parts.push(venue.city);
		}
		if(venue && venue.st){
			parts.push(venue.st);
		}
		if(venue && venue.country){
			parts.push(venue.country);
		}
		if(venue && venue.zip){
			parts.push(venue.zip);
		}
		return parts.join(', ');
	},
	get_shortlist_speaker_ids: function(event){
		return event.MPshortlist && _.isArray(event.MPshortlist.speaker_ids) ? event.MPshortlist.speaker_ids : [];
	},
	toMpURL: toMpURL,
	get_shortlist_url: function(event){
		return '#/shortlist/' + event.eid;
	},
	get_contract_url: function(event){
		return '#/contract/' + event.eid;
	},
	get_payments_url: function(event){
		return event.MPcontract && event.MPcontract.id > 0 ? toMpURL('/payment/view/' + event.MPcontract.id) : null;
	},
	get_review_url: function(event){
		var sid = this.get_selected_speaker_id(event);
		return toMpURL('/speaker/review/' + sid + '?event_id=' + event.eid);
	},
	isEventReadyForBuyerReview: function(event){
		var today = new Date();
		return today >= event.stoptime;
		//return event.MPcontract && event.MPcontract.contract_in_force && event.MPpayment && event.MPpayment.event_is_paid_for;
	},
	get_buyername_for_event: function(event){
		var buyer_names = _.map(event && event.Buyers, function(Buyer){
			return Buyer.firstname + ' ' + Buyer.lastname;
		});
		if(buyer_names.length === 0){
			buyer_names = ['the Buyer'];
		}
		return buyer_names.join(', ');
	},
	getEventVersionIdentifier: function(event){
		if(event && event.eid > 0 && event.modified){
			return event.eid + '-' + event.modified;
		}
		return null;
	},
	StoredFile_Balboa3toJS: StoredFile_Balboa3toJS,
	StoredFile_JStoBalboa3: StoredFile_Balboa3toJS,
	fixMPcontractDates: fixMPcontractDates,
	convertBalboa3ToJS: convertBalboa3ToJS,
	convertBalboa3EventToJSEvent: function(event){
		event.eid = toInt(event.eid);
		event.sids = cleanup_ids(event.sids);
		event.bureauID = toInt(event.bureauID);

		event.companyID = toInt(event.companyID);
		event.presentingproductid = toInt(event.presentingproductid);

		event.topics = _.map(event.topics, function(topic){
			return topic.replace(/\//g, ' / ').trim();
		});

		if(event.MPcontract){
			event.MPcontract = fixMPcontractDates(event.MPcontract);
		}

		if(event.budget_min > 0 && event.budget_max === 0){
			event.budget_max = Infinity;
		}

		event = FIX_fromISO8601(event, 'created');
		event = FIX_fromISO8601(event, 'ccDateTime');
		event = FIX_fromISO8601(event, 'modified');

		event.Stagetime = _.map(event.Stagetime, function(stagetime){
			stagetime.venueid = toInt(stagetime.venueid);
			return FIX_fromISO8601(stagetime, ['starttime', 'stoptime', 'avchecktime']);
		});

		event.starttime = _.min(event.Stagetime,function(stagetime){
			return _.isDate(stagetime.starttime) ? stagetime.starttime.getTime() : 0;
		}).starttime;

		event.stoptime = _.max(event.Stagetime,function(stagetime){
			return _.isDate(stagetime.stoptime) ? stagetime.stoptime.getTime() : 0;
		}).stoptime;

		event.Note = _.map(event.Note, function(note){
			return FIX_fromISO8601(note, 'datetime');
		});

		_.each(["Flight", "Hotel", "Ground", "Service"], function(key){
			event[key] = _.map(event[key], convertBalboa3ToJS[key]);
		});

		_.each(event.VideoCoaching, function(p){
			_.each(p.sessions, function(s){
				s = FIX_fromISO8601(s, "startdate");
			});
		});

		event.EventTodo = _.map(event.EventTodo, function(todo){
			todo.id = toInt(todo.id);
			todo.eid = toInt(todo.eid);
			todo.status = toInt(todo.status);
			todo.vieworder = toInt(todo.vieworder);
			todo.from_list_id = toInt(todo.from_list_id);
			todo.from_list_sid = toInt(todo.from_list_sid);
			return FIX_fromISO8601(todo, 'statusdate');
		});
		event.storedfiles = _.map(event.storedfiles, StoredFile_Balboa3toJS);
		event.todolistids = _.map(_.isString(event.todolistids) && event.todolistids.split(','), function(part){
			if (part.indexOf('|') > 0) {
				var split = part.split('|');
				return {sid: toInt(split[0]), listid: toInt(split[1])};
			} else {
				return part;
			}
		});

		return event;
	},
	convertJSEventToBalboa3Event: function(event){
		if(!_.isPlainObject(event) || !_.has(event, 'eid')){
			return null;
		}
		event = FIX_toISO8601(event, 'created');
		event = FIX_toISO8601(event, 'ccDateTime');
		event.Stagetime = _.map(event.Stagetime, function(stagetime){
			return FIX_toISO8601(stagetime, ['starttime', 'stoptime', 'avchecktime']);
		});
		event.Note = _.map(event.Note, function(note){
			return FIX_toISO8601(note, 'datetime');
		});
		event.Flight = _.map(event.Flight, function(flight){
			flight.legs = _.map(flight.legs, function(leg){
				return FIX_toISO8601(leg, ['legarrive', 'legleave']);
			});
			return flight;
		});
		event.Hotel = _.map(event.Hotel, function(hotel){
			return FIX_toISO8601(hotel, ['checkindate', 'checkoutdate']);
		});
		event.Ground = _.map(event.Ground, function(ground){
			return FIX_toISO8601(ground, 'starttime');
		});
		event.EventTodo = _.map(event.EventTodo, function(todo){
			todo.vieworder = toInt(todo.vieworder);
			return FIX_toISO8601(todo, 'statusdate');
		});
		event.Service = _.map(event.Service, function(todo){
			return FIX_toISO8601(todo, 'due');
		});
		event.storedfiles = _.map(event.storedfiles, StoredFile_JStoBalboa3);
		event.todolistids = _.map(_.filter(event.todolistids, function(todolist){
			return (
				(_.has(todolist, ["sid"]) && _.has(todolist, ["listid"])) && (_.isNumber(todolist.sid) && !_.isNaN(todolist.sid) && todolist.sid > 0 && _.isNumber(todolist.listid) && !_.isNaN(todolist.listid))
				||
				(!_.has(todolist, ["sid"]) && !_.has(todolist, ["listid"]) && (_.parseInt(todolist) > 0))
			);
		}),function(todolist){
			if (_.has(todolist, ["sid"]) && _.has(todolist, ["listid"])) {
				return todolist.sid + '|' + todolist.listid;
			} else {
				return todolist;
			}
		}).join(',');

		_.each(event.VideoCoaching, function(p){
			p.sessions = _.map(p.sessions, function(s){
				s.flags = flagsAsMap_to_Flags(s.flags_as_map);
				return FIX_toISO8601(s, "startdate");
			});
		});

		if(_.has(event, "flags_as_map")){
			event.flags = flagsAsMap_to_Flags(event.flags_as_map);
		}

		event.isPersonal = !!event.isPersonal;
		if(_.has(event, 'isPersonal_ISO8601')){
			delete event.isPersonal_ISO8601;
		}
		return event;
	},

	/////////////////////////////////////////////////////////////////////////////////////////////////////
	// Formatting Functions
	get_initials: function(name){
		return name.replace(/\W*(\w)\w*/g, '$1.').toUpperCase();
	},
	format_number: function(num, num_decimals){
		num = _.isString(num) ? parseFloat(num) : num;
		if(!_.isNumber(num) || _.isNaN(num)){
			return '0';
		}
		if(_.isNumber(num_decimals) && num_decimals >= 0){
			num = num.toFixed(num_decimals);
		}
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	},
	format_currency: function(price, num_decimals){
		return '$' + this.format_number(price, num_decimals);
	},
	format_budget_range: function(price_range, msg_on_free){
        var self = this;
        var prices = !_.isArray(price_range) ? [] : _.uniq(_.sortBy(_.filter(_.map(price_range, function(price){
            return price == Infinity || price == -Infinity ? price : _.parseInt(price);
        }), function(price){
            return price >= -1;
        })), true);

        if(prices.length === 1 && prices[0] === -1){
            return _.isString(msg_on_free) ? msg_on_free : '(to be determined)';
        }
        if(prices.length === 1 && prices[0] === 0){
            return _.isString(msg_on_free) ? msg_on_free : '(free)';
        }
        if(prices.length === 2 && prices[1] === Infinity){
            return 'More than ' + self.format_currency(prices[0], 0);
        }
        return _.map(prices,function(price){
            return self.format_currency(price, 0);
        }).join(' - ');
    },

	/////////////////////////////////////////////////////////////////////////////////////////////////////
	// Date Functions
	convertFromISO8601: convertFromISO8601,
	returnISO8601: returnISO8601,
	format_date: dateFormat,
	get_n_days_in_month: function(year, month){
		return [31, ((((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	},
	get_day_of_week: function(day_input, use_short){
		var day = parseInt(day_input);
		if(!_.isNumber(day) || _.isNaN(day)){
			return day_input;
		}
		day = (day - 1) % 7;
		day = day < 0 ? 7 + day : day;
		return dateFormat.i18n.dayNames[!use_short ? day + 7 : day];
	},
	get_month_name: function(month_input, use_short){
		var month = parseInt(month_input);
		if(!_.isNumber(month) || _.isNaN(month)){
			return month_input;
		}
		month = (month - 1) % 12;
		month = month < 0 ? 12 + month : month;
		return _.isNumber(month) ? dateFormat.i18n.monthNames[!use_short ? month + 12 : month] : month;
	},
	build_calendar_weeks: function(year, month, must_be_six_weeks){
		var d = new Date(year, month - 1, 1, 0, 0, 0, 0);
		var daysInPrevMonth = d.getMonth() === 0 ? this.get_n_days_in_month(d.getFullYear() - 1, 11) : this.get_n_days_in_month(d.getFullYear(), d.getMonth() - 1);
		var daysInThisMonth = this.get_n_days_in_month(d.getFullYear(), d.getMonth());
		var dayOfWeekStartsOn = d.getDay();
		var dateI = 1;
		var i;
		var weeks = [];

		var curWeek = [];
		for(i = 0; i < dayOfWeekStartsOn; i++){
			curWeek.push({date: daysInPrevMonth - (dayOfWeekStartsOn - i) + 1, out_of_month: true});
		}
		while(dateI <= daysInThisMonth){
			if(curWeek.length === 7){
				weeks.push(curWeek);
				curWeek = [];
			}
			curWeek.push({date: dateI});
			dateI++;
		}
		if(curWeek.length > 0){
			var daysToAdd = 7 - curWeek.length;
			for(i = 0; i < daysToAdd; i++){
				curWeek.push({date: i + 1, out_of_month: true});
			}
			weeks.push(curWeek);
			if(must_be_six_weeks){
				while(weeks.length < 6){
					curWeek = [];
					var j;
					for(j = 0; j < 7; j++){
						curWeek.push({date: i + 1, out_of_month: true});
						i++;
					}
					weeks.push(curWeek);
				}
			}
		}
		return weeks;
	},

	/////////////////////////////////////////////////////////////////////////////////////////////////////
	// Browser env related
	wrapPreventDefault: function(fn){
		return function(e){
			if(e && e.preventDefault){
				e.preventDefault();
			}
			if(e && e.stopPropagation){
				e.stopPropagation();
			}
			fn.call(this, e);
		};
	},
	encode_redir: function(url){
		return url.replace(/_/g, 'mrunderscore').replace(/\//g, '_');
	},
	decode_redir: function(url){
		return url.replace(/_/g, '/').replace(/mrunderscore/g, '_');
	},
	phpCompatibleParams: function(params){
		var parts = [];
		_.each(params, function(value, key){
			if(value === null || _.isUndefined(value))
				return;
			var is_this_array = _.isArray(value);
			if(!is_this_array){
				value = [value];
			}

			_.each(value, function(v){
				if(_.isObject(v)){
					v = JSON.stringify(v);
				}
				parts.push(encodeURIComponent(key) + (is_this_array ? '[]' : '') + '=' + encodeURIComponent(v));
			});
		});
		return parts.join('&');
	},

	/////////////////////////////////////////////////////////////////////////////////////////////////////
	// Data functions
	toInt: toInt,
	toFloat: toFloat,
	getIn: getIn,
	isValue: isValue,
	isBlank: isBlank,
	isNumber: isNumber,
	deepDiff: deepDiff,
	cleanup_ids: cleanup_ids,
	is_valid_email: (function(){
		//RFC882 email validator
		var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
		var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
		var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
		var sQuotedPair = '\\x5c[\\x00-\\x7f]';
		var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
		var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
		var sDomain_ref = sAtom;
		var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
		var sWord = '(' + sAtom + '|' + sQuotedString + ')';
		var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
		var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
		var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
		var sValidEmail = '^' + sAddrSpec + '$'; // as whole string

		var reValidEmail = new RegExp(sValidEmail);

		return function(email){
			return reValidEmail.test(email);
		};
	}())
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/utils/esUtils.js
// module id = 2
// module chunks = 0 1 2 3 4